import { render } from "./CheckoutSubmitButton.vue?vue&type=template&id=566642f0"
import script from "./CheckoutSubmitButton.vue?vue&type=script&lang=js"
export * from "./CheckoutSubmitButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__